/* eslint-disable react/no-array-index-key */
import {
  TableBody,
  TableCell,
  TableRow,
  Tooltip,
  Checkbox,
} from '@material-ui/core';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';

const useStyles = makeStyles<Theme>(() =>
  createStyles({
    btn: {
      width: '47px',
      height: '40px',
      padding: 0,
      minWidth: 'initial',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '4px',
      color: '#fff',
      marginLeft: '13px',
      '& .MuiButton-iconSizeMedium': {
        margin: '0',
      },
    },
    clip: {
      display: 'inline-block',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      maxWidth: '10ch',
    },
    textFieldSelect: {
      width: '230px',
      marginLeft: '13px',
    },
    textFieldSelectRoot: {
      borderRadius: '4px',
      height: '38px',
    },
    tabButton: {
      width: '181px',
    },
    cardRoot: {
      borderRadius: '4px',
    },
    tabs: {
      '& .MuiTab-root': {
        backgroundColor: 'transparent',
        minWidth: '120px',
      },
      '& .Mui-selected': {
        backgroundColor: '#231F20',
        color: '#fff',
      },
    },
    tableHead: {
      '& .MuiTableCell-root': {
        textTransform: 'capitalize',
      },
    },
    tableRow: {
      textDecoration: 'none',
      '& :hover': {
        cursor: 'pointer',
      },
      '& .ticketStatusTrue': {
        backgroundColor: 'rgba(7, 83, 0, 0.16)',
        color: '#1D7A15',
        padding: '5px',
        fontWeight: 'Bold',
      },
      '& .ticketStatusFalse': {
        background: '#DEEBFF',
        color: '#3375D7',
        padding: '5px',
        fontWeight: 'Bold',
      },
    },
    priorityComponent: {
      height: '30px',
      background: 'rgba(189,189,189,0.1)',
      color: '#000000aa',
      width: '100px',
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      textTransform: 'capitalize',
      justifyContent: 'center',
    },
    loaderTable: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      zIndex: '2222',
    },
  })
);

type CustomBodyProps = {
  rows: any;
  columns: any;
  editBaseRoute?: string;
  onRowClick?: any;
  showCheckbox: boolean;
  checkedIds: string[];
  setCheckedIds: React.Dispatch<React.SetStateAction<string[]>>;
};
const CustomTableBody = ({
  rows,
  columns,
  editBaseRoute,
  onRowClick = () => { },
  showCheckbox,
  checkedIds,
  setCheckedIds,
}: CustomBodyProps) => {
  const classes = useStyles();
  const location = useLocation();

  const handleClick = (event: React.MouseEvent<unknown>, id: string) => {
    event.stopPropagation();
    const selectedIndex = checkedIds.indexOf(id);
    let newSelected: readonly string[] = [];

    if (selectedIndex === -1) {
      newSelected = [...checkedIds, id];
    } else {
      newSelected = [
        ...checkedIds.slice(0, selectedIndex),
        ...checkedIds.slice(selectedIndex + 1),
      ];
    }

    setCheckedIds(newSelected as string[]);
  };

  const isSelected = (id: string) => checkedIds.indexOf(id) !== -1;

  // Tooltip handler function
  const getTooltipLabel = (row: any, column: any) => {
    if (column.id === 'isActive') {
      return row[column.id] ? 'Active' : 'Inactive';
    }
    return row[column.id]
      ? row[column.id]
      : column.label || 'No data available';
  };

  return (
    <TableBody style={{ position: 'relative' }}>
      {rows?.length ? (
        rows?.map((row: any) => {
          const isItemSelected = showCheckbox ? isSelected(row.id) : false;

          return (
            <TableRow
              hover
              onClick={(event) => {
                // const isCheckboxClick = (event.target as HTMLElement).closest('[role="checkbox"]');
                // if (!isCheckboxClick) {
                onRowClick(row);
                // }
              }}
              role="checkbox"
              aria-checked={isItemSelected}
              tabIndex={-1}
              key={row.id}
              selected={isItemSelected}
              sx={{ cursor: 'pointer' }}>
              {showCheckbox && (
                <TableCell padding="checkbox">
                  <Checkbox
                    color="primary"
                    checked={isItemSelected}
                    onClick={(event) => handleClick(event, row.id)}
                  />
                </TableCell>
              )}
              {columns?.map((column: any, index: any) => (
                <TableCell
                  key={`${row?.id}-${row[column.id]}-${index}`}
                  sx={{
                    width: column.width ?? 'auto',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    fontSize: '12px',
                  }}
                  align="left"
                  size="small">
                  {/* <Tooltip title={getTooltipLabel(row, column)}>
                    <span>
                      {column?.Cell
                        ? column?.Cell(row[column.id], row)
                        : row[column?.id] || '-'}
                    </span>
                  </Tooltip> */}

                  <Tooltip title={typeof getTooltipLabel(row, column) === 'object' ? '' : getTooltipLabel(row, column)}>
                    <span>
                      {
                        // eslint-disable-next-line react/jsx-no-comment-textnodes
                        (() => {
                          if (column?.Cell) return column.Cell(row[column.id], row);
                          if (row[column?.id] != null) return row[column?.id];
                          return '-';
                        })()
                      }
                    </span>
                  </Tooltip>

                </TableCell>
              ))}
            </TableRow>
          );
        })
      ) : (
        <TableRow>
          <TableCell
            colSpan={showCheckbox ? columns?.length + 1 : columns?.length}
            sx={{ textAlign: 'center' }}>
            No Data Found
          </TableCell>
        </TableRow>
      )}
    </TableBody>
  );
};

export default CustomTableBody;
